<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs"
             v-on="on"
             x-small>
        Options
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item :to="{name: 'admin.share_template.show', params: {templateID: template.id}}">
        <v-list-item-title>
          Performance
        </v-list-item-title>
      </v-list-item>
      <ShareTemplateImageDialog :template="template">
        <template #activator="{ on, attrs, openDialog }">
          <v-list-item v-bind="attrs"
                       v-on="on"
                       @click="openDialog">
            <v-list-item-title>
              Quick View
            </v-list-item-title>
          </v-list-item>
        </template>
      </ShareTemplateImageDialog>
      <v-list-item v-if="1===2"
                   :href="template.preview_url"
                   target="_blank">
        <v-list-item-title>
          Preview
        </v-list-item-title>
      </v-list-item>
      <v-list-item :to="{name: 'admin.share_template.edit', params: {templateID: template.id}}">
        <v-list-item-title>
          Edit
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="template.is_unlayer"
                   :to="{name: 'admin.share_template.unlayer.edit', params: {templateID: template.id}}">
        <v-list-item-title>
          Edit Design
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="template.is_unlayer"
                   @click.prevent="downloadDesign">
        <v-list-item-title>
          Download Design
        </v-list-item-title>
      </v-list-item>
      <v-list-item :href="template.send_email_url"
                   target="_blank">
        <v-list-item-title>
          Send Test
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="team.email_composer_enabled === false && team.campaigns_enabled && template.is_campaign"
                   :href="template.send_campaign_url"
                   target="_blank">
        <v-list-item-title>
          Send Test Campaign
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="emailPreviewsEnabled"
                   :to="{name: 'admin.mailgun.email_preview.create', query: {template_id: template.id}}">
        <v-list-item-title>
          Create Email Preview
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="template.can_be_copied"
                   :to="{name: 'admin.share_template.create', query: {source: template.id}}">
        <v-list-item-title>
          Copy
        </v-list-item-title>
      </v-list-item>
      <v-list-item v-if="template.can_be_copied && isOnOtherTeams"
                   :to="{name: 'admin.share_template.copy_to_team', params: {templateID: template.id}}">
        <v-list-item-title>
          Copy to another team
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click.prevent="downloadPDF">
        <v-list-item-title>
          Download PDF
        </v-list-item-title>
      </v-list-item>
      <v-list-item :to="{name: 'admin.share_template.audit_trail', params: {templateID: template.id}}">
        <v-list-item-title>
          Audit Trail
        </v-list-item-title>
      </v-list-item>
      <v-list-item :to="{name: 'admin.share_template.delete', params: {templateID: template.id}}">
        <v-list-item-title>
          Delete
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import {mapGetters} from "vuex";
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import ShareTemplateImageDialog from './ShareTemplateImageDialog.vue';

export default {
  components: {ShareTemplateImageDialog},
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'canTestEmailTemplates', // MLD-4550
      'emailPreviewsEnabled',
      'isOnOtherTeams', // MLD-3800
      'team',
      'user',
    ]),
  },
  methods: {
    downloadDesign() { // MLD-6456
      shareTemplateService.downloadJSON(this.template, this.template.design);
    },
    async downloadPDF() { // MLD-7683
      await shareTemplateService.downloadPDF(this.template, {});
    }
  }
}
</script>
